import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {HttpClient} from '../../common/http.client';
import {environment} from 'environments/environment';
import {fetchLayerData} from './fetch-layer-data'
import {MAP_TYPES, FORMATS} from './fetch-layer-data/api/maps-api-common'
import {API_VERSIONS} from './fetch-layer-data/api/maps-api-common'

@Injectable()
export class MvtService {
    getAlertLevel: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    iconAtlas: BehaviorSubject<{ atlas: string, mapping: string }> = new BehaviorSubject<{ atlas: string, mapping: any }>({
        atlas: null,
        mapping: null
    });

    constructor(protected http: HttpClient) {
    }

    async getMVT(id, sql: any) {
        // @ts-ignore
        const response = await fetchLayerData({
            type: MAP_TYPES.QUERY,
            source: sql,
            format: FORMATS.GEOJSON,
            connection: environment.carto.connection,
            credentials: {
                apiVersion: API_VERSIONS.V3,
                apiBaseUrl: environment.carto.apiBaseUrl,
                accessToken: environment.carto.accessToken
            }
        })

        return response.data;
    }

    getAPIData(sql) {
        return this.http.get(`https://${environment.options['cartoAccount']}.carto.com/api/v2/sql?q=${sql}`).map(response => {
            return response.json();
        });
    }

    async getSQLData(sql, queryParameters) {
        try {
            const url = environment.carto.apiBaseUrl + environment.carto.sqlEndpoint + '?q=' + sql
            const body = {
                headers: {
                    'Authorization': 'Bearer ' + environment.carto.accessToken
                },
                queryParameters,
            }

            const response = await fetch(url, body)
            return await response.json()
        } catch (err) {
            console.error(`Error fetching sql data: ${err}`)
        }
    }

    updateAlertLevel(level) {
        this.getAlertLevel.next(level);
    }

    getIconAtlas() {
        if (this.iconAtlas.getValue().atlas) {
            return Promise.resolve(this.iconAtlas.getValue());
        } else {
            return this.http.get('/assets/sprite/markers@3x.json').map((rsp) => {
                this.iconAtlas.next({
                    atlas: '/assets/sprite/markers@3x.png',
                    mapping: rsp.json(),
                });
                return this.iconAtlas.getValue();
            }).toPromise();
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/common/services/mvt.service.ts